// Apply a Node.js transform stream to an Observable
"use strict";
var Observable_1 = require("rxjs/Observable");
require("rxjs/add/observable/of");
require("rxjs/add/observable/fromEvent");
require("rxjs/add/observable/race");
require("../add/observable/fromNodeReadableStream");
require("rxjs/add/operator/concatMap");
require("rxjs/add/operator/delay");
require("rxjs/add/operator/first");
require("rxjs/add/operator/let");
/************************************************
 * Find a delay (ms) to match the transform stream,
 * increasing when a write returns false
 * (Node stream signal to initiate backpressure)
 * and decreasing when it does (min 0).
 ************************************************/
function getDelay(bpWarningCount, previousDelay, delay) {
    var nextDelay;
    if (bpWarningCount === 0) {
        nextDelay = (previousDelay + delay) / 2;
    }
    else {
        nextDelay = Math.pow(2, bpWarningCount - 1) * Math.max(delay, 1);
    }
    return Math.ceil(nextDelay);
}
/**
 * throughNodeStream
 *
 * @param {Stream} transformStream
 * @param {Object} [options={delay: 0}]
 * @param {Number} options.delay delay (in ms)
 * @return {Observable}
 */
function throughNodeStream(transformStream, options) {
    if (options === void 0) { options = { delay: 0 }; }
    // this is the number of consecutive times, starting with the most recent write
    // and going backwards, that we've received a backpressure warning after a write.
    var bpWarningCount = 0;
    var delay = options.delay;
    var previousDelay = delay;
    // 'drain' event added in Node v0.9.4,
    // so we're actually using two mechanisms
    // for handling backpressure:
    // * the drain event, and
    // * a backoff algorithm, in case "drain" is
    //   not supported by the current stream.
    var drainSource = Observable_1.Observable.fromEvent(transformStream, 'drain')
        .do(function () {
        bpWarningCount = 0;
    });
    return this.let(function (observable) {
        var transformObservable = Observable_1.Observable.fromNodeReadableStream(transformStream, 'end');
        observable.concatMap(function (x) {
            var delayableSource = Observable_1.Observable.of(x);
            if (delay === 0) {
                return delayableSource;
            }
            else {
                return Observable_1.Observable.race(drainSource.first().concatMap(function (x) { return delayableSource; }), delayableSource.delay(delay));
            }
        })
            .subscribe(function (input) {
            // push some data
            var pushResponse = transformStream.write(input);
            // NOTE: if response is false, we must delay (backpressure).
            // Semi-related backpressure discussion for RxJS 5:
            // https://github.com/ReactiveX/rxjs/issues/71#issuecomment-228824763
            if (!pushResponse) {
                bpWarningCount += 1;
            }
            else {
                bpWarningCount = 0;
            }
            var nextDelay = getDelay(bpWarningCount, previousDelay, delay);
            previousDelay = delay;
            delay = nextDelay;
        }, function (err) {
            err.message = (err.message || '') + ' in Rx.Observable.prototype.throughNodeStream';
            throw err;
        }, function () {
            transformStream.end();
        });
        return transformObservable;
    });
}
exports.throughNodeStream = throughNodeStream;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhyb3VnaE5vZGVTdHJlYW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvb3BlcmF0b3IvdGhyb3VnaE5vZGVTdHJlYW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsb0RBQW9EOztBQUVwRCw4Q0FBNkM7QUFDN0Msa0NBQWdDO0FBQ2hDLHlDQUF1QztBQUN2QyxvQ0FBa0M7QUFDbEMsb0RBQWlEO0FBRWpELHVDQUFxQztBQUNyQyxtQ0FBaUM7QUFDakMsbUNBQWlDO0FBQ2pDLGlDQUErQjtBQUUvQjs7Ozs7a0RBS2tEO0FBQ2xELGtCQUNFLGNBQXNCLEVBQ3RCLGFBQXFCLEVBQ3JCLEtBQWE7SUFFZCxJQUFJLFNBQVMsQ0FBQztJQUNkLEVBQUUsQ0FBQyxDQUFDLGNBQWMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBQzFCLFNBQVMsR0FBRyxDQUFDLGFBQWEsR0FBRyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7SUFDekMsQ0FBQztJQUFDLElBQUksQ0FBQyxDQUFDO1FBQ1AsU0FBUyxHQUFHLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxFQUFFLGNBQWMsR0FBRyxDQUFDLENBQUMsR0FBRyxJQUFJLENBQUMsR0FBRyxDQUFDLEtBQUssRUFBRSxDQUFDLENBQUMsQ0FBQztJQUNsRSxDQUFDO0lBQ0QsTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLENBQUM7QUFDN0IsQ0FBQztBQUVEOzs7Ozs7O0dBT0c7QUFDSCwyQkFFRSxlQUF1QyxFQUN2QyxPQUE2QjtJQUE3Qix3QkFBQSxFQUFBLFlBQW9CLEtBQUssRUFBRSxDQUFDLEVBQUM7SUFFOUIsK0VBQStFO0lBQy9FLGlGQUFpRjtJQUNqRixJQUFJLGNBQWMsR0FBRyxDQUFDLENBQUM7SUFDdkIsSUFBSSxLQUFLLEdBQUcsT0FBTyxDQUFDLEtBQUssQ0FBQztJQUMxQixJQUFJLGFBQWEsR0FBRyxLQUFLLENBQUM7SUFDMUIsc0NBQXNDO0lBQ3RDLHlDQUF5QztJQUN6Qyw2QkFBNkI7SUFDN0IseUJBQXlCO0lBQ3pCLDRDQUE0QztJQUM1Qyx5Q0FBeUM7SUFDekMsSUFBSSxXQUFXLEdBQUcsdUJBQVUsQ0FBQyxTQUFTLENBQUMsZUFBZSxFQUFFLE9BQU8sQ0FBQztTQUMvRCxFQUFFLENBQUM7UUFDSCxjQUFjLEdBQUcsQ0FBQyxDQUFDO0lBQ3BCLENBQUMsQ0FBQyxDQUFDO0lBQ0gsTUFBTSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsVUFBUyxVQUFVO1FBQ2xDLElBQUksbUJBQW1CLEdBQUcsdUJBQVUsQ0FBQyxzQkFBc0IsQ0FDekQsZUFBZSxFQUNmLEtBQUssQ0FDTixDQUFDO1FBRUYsVUFBVSxDQUFDLFNBQVMsQ0FBQyxVQUFTLENBQUM7WUFDOUIsSUFBSSxlQUFlLEdBQUcsdUJBQVUsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFDdkMsRUFBRSxDQUFDLENBQUMsS0FBSyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUM7Z0JBQ2pCLE1BQU0sQ0FBQyxlQUFlLENBQUM7WUFDeEIsQ0FBQztZQUFDLElBQUksQ0FBQyxDQUFDO2dCQUNQLE1BQU0sQ0FBQyx1QkFBVSxDQUFDLElBQUksQ0FDckIsV0FBVyxDQUFDLEtBQUssRUFBRSxDQUFDLFNBQVMsQ0FBQyxVQUFBLENBQUMsSUFBSSxPQUFBLGVBQWUsRUFBZixDQUFlLENBQUMsRUFDbkQsZUFBZSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FDNUIsQ0FBQztZQUNILENBQUM7UUFDRixDQUFDLENBQUM7YUFDRCxTQUFTLENBQ1IsVUFBUyxLQUFLO1lBQ2IsaUJBQWlCO1lBQ2pCLElBQUksWUFBWSxHQUFHLGVBQWUsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLENBQUM7WUFDaEQsNERBQTREO1lBQzVELG1EQUFtRDtZQUNuRCxxRUFBcUU7WUFDckUsRUFBRSxDQUFDLENBQUMsQ0FBQyxZQUFZLENBQUMsQ0FBQyxDQUFDO2dCQUNuQixjQUFjLElBQUksQ0FBQyxDQUFDO1lBQ3JCLENBQUM7WUFBQyxJQUFJLENBQUMsQ0FBQztnQkFDUCxjQUFjLEdBQUcsQ0FBQyxDQUFDO1lBQ3BCLENBQUM7WUFDRCxJQUFJLFNBQVMsR0FBRyxRQUFRLENBQUMsY0FBYyxFQUFFLGFBQWEsRUFBRSxLQUFLLENBQUMsQ0FBQztZQUMvRCxhQUFhLEdBQUcsS0FBSyxDQUFDO1lBQ3RCLEtBQUssR0FBRyxTQUFTLENBQUM7UUFDbkIsQ0FBQyxFQUNELFVBQVMsR0FBRztZQUNYLEdBQUcsQ0FBQyxPQUFPLEdBQUcsQ0FBQyxHQUFHLENBQUMsT0FBTyxJQUFJLEVBQUUsQ0FBQyxHQUFHLCtDQUErQyxDQUFDO1lBQ3BGLE1BQU0sR0FBRyxDQUFDO1FBQ1gsQ0FBQyxFQUNEO1lBQ0MsZUFBZSxDQUFDLEdBQUcsRUFBRSxDQUFDO1FBQ3ZCLENBQUMsQ0FDRixDQUFDO1FBRUYsTUFBTSxDQUFDLG1CQUFtQixDQUFDO0lBQzVCLENBQUMsQ0FBQyxDQUFDO0FBQ0osQ0FBQztBQWhFRCw4Q0FnRUMifQ==


//////////////////
// WEBPACK FOOTER
// ./~/rx-extra/operator/throughNodeStream.js
// module id = 417
// module chunks = 0